/* REACT */
import React, { Component, Fragment, createRef } from 'react';
import {Box} from '@material-ui/core';
import Media from 'react-media';

/* Components */
import Menu from '../childrens/menu/.mixins';

/* CSS */
import './App.css';

export const childMenu = createRef();

const TelaDesktop = (props) => {
  return (
    <div>
      <Box className="App" p={1}>
          <nav>
            <Menu {...props} ref={childMenu}/>
          </nav>
          <main>
            {props.props.children}
          </main>
      </Box>
    </div>
  );
};

const TelaMobile = (props) => {
  return (
    <div>
      <Box className="App" style={{paddingTop: 64}} p={1}>
        <nav>
          <Menu {...props} ref={childMenu}/>
        </nav>
        <main>
          {props.props.children}
        </main>
      </Box>
    </div>
  );
};

const TelaTablet = (props) => {
  return (
    <div>
      <Box className="App" style={{paddingTop: 64}} p={1}>
        <nav>
          <Menu {...props} ref={childMenu}/>
        </nav>
        <main>
          {props.props.children}
        </main>
      </Box>
    </div>
  );
};

export default class App extends Component {
  render () {
    return (
      <div>
        <Media queries={{
          small: "(max-width: 599px)",
          medium: "(min-width: 600px) and (max-width: 1199px)",
          large: "(min-width: 1200px)"
        }}>
            {matches =>
              <Fragment>
                  {matches.small && <TelaMobile {...this}/>}
                  {matches.medium && <TelaTablet {...this}/>}
                  {matches.large && <TelaDesktop {...this}/>}
              </Fragment>
            }
        </Media>
      </div>
    );
  }
}